import { useWindowWidth } from "@react-hook/window-size";
import { MOBILE_BREAKPOINT } from "@olivahealth/oli-ui/utils/breakpoints";

interface UseSmallScreenDetectionProps {
  breakpoint?: number;
}

export default function useSmallScreenDetection({
  breakpoint = MOBILE_BREAKPOINT,
}: UseSmallScreenDetectionProps = {}) {
  const width = useWindowWidth();

  return width < breakpoint;
}
